export const msalConfig = {
    auth: {
      clientId: "2ae03af0-ce39-4cb4-8fb2-b9ef82c285aa",
      authority: "https://login.microsoftonline.com/990436a6-87df-491c-9124-9afa91f88827",
      redirectUri: "https://cssvn.utrgv.edu",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
export const loginRequest = {
    scopes: ["api://72dc26b6-6053-4e1c-a01f-9ec8c54c222c/access_as_user"]
  };
  
export const apiRequest  = {
      server: "https://cssvn.utrgv.edu/ptlapi"
  };

export const discordInvite = "https://discord.gg/YqmE4dHbrp";
